import { render, staticRenderFns } from "./DataSets.vue?vue&type=template&id=669e8dcf&scoped=true&lang=pug"
import script from "./DataSets.vue?vue&type=script&lang=js"
export * from "./DataSets.vue?vue&type=script&lang=js"
import style0 from "./DataSets.vue?vue&type=style&index=0&id=669e8dcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e8dcf",
  null
  
)

export default component.exports